import { requester } from '../utils';

export const financialTransaction = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/financialTransaction/me`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get financial transaction error', err);
        reject(err);
      });
  });
};

export const financialTransactionTypes = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/financialTransaction/types`,
        method: 'GET',
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get financial transaction types error', err);
        reject(err);
      });
  });
};
